import React, { PropTypes } from 'react'
import PresseTeaser from './PresseTeaser'

function PresseList(props) {
return <div className='row'>
{ props
	.posts
	.map( (p, i) =>
		 <div key={ i } className='col-sm-6 col-md-4'>
			 <PresseTeaser {...p} defaultType={ props.defaultType } />
		 </div>
	)
}
</div>
}

PresseList.propTypes = {
	posts: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default PresseList



// WEBPACK FOOTER //
// ./js/website/react_components/PresseList.js